import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { validateAvailabilityRequirements } from "PFCore/services/availability_requirements/validate_availability_requirements";
import { AvailabilityRuleV2 } from "PFCore/types";
import { MutationOptions } from "PFCore/types/request_options";

const AVAILABILITY_VALIDATION_KEY = ["availabilityRequirementsValidation"];

export const useAvailabilityRequirementsValidation = (
  options: MutationOptions<Partial<AvailabilityRuleV2>, void, AxiosError> = {}
) =>
  useMutation<void, AxiosError, Partial<AvailabilityRuleV2>>({
    mutationKey: AVAILABILITY_VALIDATION_KEY,
    mutationFn: (availability) => validateAvailabilityRequirements(availability),
    ...options
  });
